import { useRef, useLayoutEffect } from 'react';
import { useGetTenantProfileQuery } from 'redux/apiSlice/tenant.slices';
import useDeviceType from 'hooks/useDeviceType';
import { useAppDispatch } from 'redux/store';
import appSlice from 'redux/slices/app.slice';
import MobileHeader from './components/MobileHeader';
import DesktopHeader from './components/DesktopHeader';

const Header = () => {
  useGetTenantProfileQuery(null);
  const { isMobile } = useDeviceType();
  const dispatch = useAppDispatch();
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!ref.current) {
      dispatch(appSlice.actions.setHeaderHeight(0));
      return;
    }

    dispatch(appSlice.actions.setHeaderHeight(ref.current.offsetHeight));
    const resizeObserver = new ResizeObserver(([entry]) => {
      const { height } = entry.contentRect;
      dispatch(appSlice.actions.setHeaderHeight(height));
    });

    resizeObserver.observe(ref.current);

    return () => resizeObserver.disconnect();
  }, [dispatch, isMobile]);

  return <div ref={ref}>{isMobile ? <MobileHeader /> : <DesktopHeader />}</div>;
};

export default Header;
